import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { UserButton, useUser } from '@clerk/clerk-react';
import { EditContext } from '../context/EditContext';
import '../pages/Admin.css';

export default function AdminBar() {
  const { pathname } = useLocation();
  const { isLoaded, isSignedIn, user } = useUser();
  const { editMode, toggleEditMode } = useContext(EditContext);

  if (!isLoaded || !isSignedIn) return null;
  if (user?.publicMetadata?.role !== 'admin') return null;
  if (pathname.startsWith('/admin')) return null;

  return (
    <>
      <div className="admin-bar" role="region" aria-label="Admin toolbar">
        <div className="admin-bar-inner">
          <span className="admin-bar-brand">
            {editMode ? 'Editing cahandcraft.com' : 'Signed in — click to edit'}
          </span>
          <label className="admin-bar-toggle">
            <input
              type="checkbox"
              checked={editMode}
              onChange={toggleEditMode}
              aria-label="Edit mode"
            />
            <span className="admin-bar-toggle-slider" />
            <span className="admin-bar-toggle-label">Edit mode</span>
          </label>
          <Link to="/admin" className="admin-bar-link">Full dashboard</Link>
          <div className="admin-bar-user">
            <UserButton afterSignOutUrl="/" />
          </div>
        </div>
      </div>
      <div className="admin-bar-spacer" aria-hidden="true" />
    </>
  );
}
